import React, { createContext, useContext, ReactNode } from 'react'
import { Metric } from './types'

export interface MyTargetPerformanceContextValue {
    data: Metric[] | undefined
    isLoading: boolean
    isError: boolean
    refetch: () => void
    error: unknown
}

const MyTargetPerformanceContext = createContext<
    MyTargetPerformanceContextValue | undefined
>(undefined)

export interface MyTargetPerformanceProviderProps {
    children: ReactNode
    value: MyTargetPerformanceContextValue
}

export const MyTargetPerformanceProvider: React.FC<
    MyTargetPerformanceProviderProps
> = ({ children, value }) => {
    return (
        <MyTargetPerformanceContext.Provider value={value}>
            {children}
        </MyTargetPerformanceContext.Provider>
    )
}

export const useMyTargetPerformanceContext =
    (): MyTargetPerformanceContextValue => {
        const context = useContext(MyTargetPerformanceContext)
        if (!context) {
            throw new Error(
                'useMyTargetPerformanceContext must be used within a MyTargetPerformanceProvider',
            )
        }
        return context
    }
